"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var padding_1 = require("../../padding");
function FlowBody(_a) {
    var borderRadius = _a.borderRadius, backgroundColor = _a.backgroundColor, children = _a.children, maxWidth = _a.maxWidth;
    return (React.createElement(padding_1.Padding, { y: 88 },
        React.createElement(StyledBody, { maxWidth: maxWidth, borderRadius: borderRadius, backgroundColor: backgroundColor }, children)));
}
exports.default = FlowBody;
var StyledBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background: ", ";\n  border-radius: ", ";\n  margin: 0 auto;\n  max-width: ", ";\n  position: relative;\n  width: ", ";\n"], ["\n  background: ", ";\n  border-radius: ", ";\n  margin: 0 auto;\n  max-width: ", ";\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor || '#fff';
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return (borderRadius ? "".concat(borderRadius, "px") : '');
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "".concat(maxWidth, "px") : '596px;');
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "".concat(maxWidth, "px") : '596px;');
});
var templateObject_1;
//# sourceMappingURL=flow-body.js.map